import React from "react";
import  './extras.css'

export function Legals() {
  return (
    <div className="ContainerAll" style={{ userSelect: 'none', WebkitUserSelect: 'none', marginBottom:"3%"}}>
        <div className="boxTitles"> 
            <hgroup className="ContainerUp">
                <h2>Aviso Legal y Condiciones de Uso</h2>
                <h5>Bienvenido a Coronados del bien.</h5>
            </hgroup>
            <p>
            Te invitamos a leer con atención este Aviso Legal, el cual regula el
            acceso, la navegación y el uso de nuestra plataforma web. Al
            permanecer y navegar en este sitio, asumís la condición de usuario y
            aceptás de manera plena, y sin reservas, todas las disposiciones
            incluidas en este documento. Nuestro compromiso es garantizarte un
            entorno digital seguro, transparente y confiable.
            </p>
      </div>
      <div className="boxP">
        <h4>1. Información Identificativa y Contacto</h4>
        <p>
          En cumplimiento con los deberes de información y transparencia que
          rigen los servicios de la sociedad de la información y el comercio
          electrónico, se detallan a continuación los datos del titular de este
          sitio web:
        </p>
        <ol>
          <li> Denominación del Sitio: Coronados del bien</li>
          <li>
             Actividad Principal: [Ej. Blog de divulgación, Plataforma cultural,
            Comunidad digital, etc.]
          </li>
          <li>
             Correo Electrónico de Contacto: [Tu Correo Electrónico Oficial]
          </li>
        </ol>
        <p>
          Para cualquier consulta, sugerencia o comunicación formal, podés
          ponerte en contacto con nosotros a través de la dirección de correo
          electrónico mencionada arriba. Nos entusiasma escucharte y
          responderemos a la brevedad posible.
        </p>
      </div>
      <div className="boxP">
        <h4>2. Propiedad Intelectual e Industrial</h4>
        <p>
          La estructura de este sitio web, sus diseños, logotipos, textos,
          combinaciones de colores, ilustraciones, códigos fuente y demás
          elementos protegibles son propiedad exclusiva de Coronados del bien o,
          en su defecto, contamos con las licencias y autorizaciones necesarias
          para su uso legítimo.
        </p>
        <ol>
          <li>
             Uso Autorizado: Como usuario, se te concede una licencia limitada
            para visualizar los contenidos y, si lo deseas, descargarlos o
            imprimirlos exclusivamente para tu uso personal, privado y no
            comercial.
          </li>
          <li>
             Prohibiciones: Queda estrictamente prohibida la reproducción total
            o parcial, distribución, modificación o explotación comercial de los
            contenidos de este sitio sin la autorización previa, expresa y por
            escrito de sus titulares. Valoramos la creatividad y el respeto al
            trabajo intelectual; ayudanos a preservarlo.
          </li>
        </ol>
      </div>
      <div className="boxP">
        <h4>3. Condiciones de Uso y Responsabilidad del Usuario</h4>
        <p>
          El acceso a Coronados del bien es libre y gratuito. Como usuario, te
          comprometés a hacer un uso adecuado, lícito y de buena fe de los
          contenidos y servicios que ofrecemos.
        </p>
        <p>Te obligás de manera expresa a no emplear el sitio para:</p>
        <ol>
          <li>
             Incurrir en actividades ilícitas, ilegales o contrarias a la buena
            fe y al orden público.
          </li>
          <li>
             Difundir contenidos de carácter racista, xenófobo,
            pornográfico-ilegal, de apología del terrorismo o atentatorio contra
            los derechos humanos.
          </li>
          <li>
             Provocar daños en los sistemas físicos y lógicos de la plataforma,
            de sus proveedores o de terceras personas (como la introducción de
            virus informáticos).
          </li>
        </ol>
      </div>
      <div className="boxP">
        <h4>4. Exclusión de Garantías y Responsabilidad</h4>
        <p>
          En Coronados del bien trabajamos con dedicación y rigurosidad para que
          los contenidos sean precisos, actualizados y estén libres de errores
          técnicos. Sin embargo, el mundo digital es dinámico y, por lo tanto,
          no podemos garantizar la infalibilidad absoluta de la plataforma.
        </p>
        <p>Bajo ninguna circunstancia nos hacemos responsables de:</p>
        <ol>
          <li>
             La falta de disponibilidad, mantenimiento o continuidad en el
            funcionamiento de la web (aunque siempre haremos lo posible por
            restablecer el servicio rápidamente).
          </li>
          <li>
             La existencia de virus o programas maliciosos en los contenidos, a
            pesar de haber adoptado todas las medidas tecnológicas necesarias
            para evitarlos.
          </li>
          <li>
             El uso ilícito, negligente o fraudulento del sitio web por parte de
            los usuarios.
          </li>
        </ol>
      </div>
      <div className="boxP">
        <h4>5. Enlaces a Terceros (Links)</h4>
        <p>
          Nuestros contenidos pueden incluir enlaces a sitios web de terceros
          que consideramos de tu interés. No obstante, Coronados del bien no
          ejerce ningún tipo de control sobre dichos sitios ni sobre sus
          políticas de privacidad.
        </p>
        <p>
          La inclusión de estos enlaces se realiza exclusivamente con fines
          informativos y de conveniencia para el lector. No asumimos
          responsabilidad alguna por los contenidos, servicios o prácticas de
          las páginas enlazadas, ni su inclusión implica que exista una
          asociación o aprobación de sus productos con nuestra marca.
        </p>
      </div>
      <div className="boxP">
        <h4>6. Modificaciones del Aviso Legal</h4>
        <p>
          El entorno digital y los marcos regulatorios evolucionan
          constantemente. Por ello, nos reservamos el derecho de modificar,
          actualizar o adaptar el presente Aviso Legal en cualquier momento para
          reflejar cambios legales o mejoras operativas en la plataforma.
        </p>
        <p>
          Te recomendamos visitar esta sección de manera periódica. Las
          modificaciones serán plenamente vigentes desde el momento de su
          publicación en este espacio.
        </p>
      </div>
      <div className="boxP">
        <h4>7. Legislación Aplicable y Jurisdicción</h4>
        <p>
          Para la resolución de todas las controversias o cuestiones
          relacionadas con este sitio web o de las actividades en él
          desarrolladas, se aplicará la legislación vigente en [Tu País/Región,
          ej. la República Argentina]. Las partes se someten expresamente a la
          jurisdicción de los Juzgados y Tribunales competentes de la ciudad de
          [Tu Ciudad], renunciando a cualquier otro fuero que pudiera
          corresponderles.
        </p>
      </div>
    </div>
  );
}
